import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const InlineCode = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		className={props.className}
		ref={ref}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		focusable="false"
		aria-hidden="true"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M1.016 1a.75.75 0 0 0 0 1.5H15.25a.75.75 0 0 0 0-1.5H1.016ZM12.2 7.25a.75.75 0 0 0 0 1.5h3.05a.75.75 0 0 0 0-1.5H12.2ZM.266 14.25a.75.75 0 0 1 .75-.75H15.25a.75.75 0 1 1 0 1.5H1.016a.75.75 0 0 1-.75-.75ZM9.105 8.3a.602.602 0 0 1-.127.195L7.1 10.418a.58.58 0 0 1-.822-.007.608.608 0 0 1-.008-.843L7.566 8.24a.243.243 0 0 0 0-.34L6.27 6.572a.601.601 0 0 1-.179-.427.614.614 0 0 1 .172-.43.586.586 0 0 1 .42-.176.575.575 0 0 1 .417.183l1.877 1.923a.602.602 0 0 1 .171.425.613.613 0 0 1-.044.23ZM2.878 5.722a.585.585 0 0 0-.415-.176.574.574 0 0 0-.414.176L.172 7.645A.602.602 0 0 0 0 8.07a.613.613 0 0 0 .172.425l1.877 1.923a.585.585 0 0 0 .416.183.574.574 0 0 0 .42-.176.602.602 0 0 0 .172-.43.614.614 0 0 0-.179-.427L1.582 8.24a.243.243 0 0 1 0-.34l1.296-1.328a.602.602 0 0 0 .172-.425.613.613 0 0 0-.172-.425ZM4.106 10.834a.583.583 0 0 1-.58-.496.616.616 0 0 1 .004-.235l.939-4.327a.602.602 0 0 1 .258-.377.576.576 0 0 1 .811.184.615.615 0 0 1 .078.454l-.938 4.327a.604.604 0 0 1-.206.338.579.579 0 0 1-.366.132Z"></path>
	</svg>
))
